<template>
  <LoadingScreen id="loading-screen" />
  <Navbar />
  <div class="reset-prompt">
    <h1>Reset your password</h1>
    <p>We recommend chosing a strong password that you will rememeber.</p>
    <form @submit.prevent="changePassword">
      <div class="input-field">
        <fa class="icon" icon="key" />
        <input
          required
          type="password"
          placeholder="New Password"
          v-model="newPassword"
          id="new-password"
        />
        <div
          class="show-pass"
          @click="showPass('new-password')"
          id="show-new-password"
        >
          <fa class="icon" icon="eye" />
        </div>
      </div>
      <Button text="Change" icon="check" />
    </form>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Button from "@/components/Button.vue";
import axios from "axios";
import Swal from "sweetalert2";
import LoadingScreen from "@/components/LoadingScreen.vue";

const Toast = Swal.mixin({
  toast: true,
  position: "bottom-right",
  showConfirmButton: false,
  timer: 5000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

export default {
  name: "ResetPassword",
  components: {
    Navbar,
    Button,
    LoadingScreen,
  },
  data() {
    return {
      email: "",
      id: "",
      newPassword: "",
    };
  },
  mounted() {
    let title = "Reset Password - Dating4Pets";
    document.title = title;
    let jwt = localStorage.getItem("jwt");

    if (jwt != null) {
      this.$router.push("/");
    }
    const headers = {
      Authorization: "Bearer " + jwt,
    };

    axios
      .get(`${process.env.VUE_APP_BACKEND}/users/info`, {
        headers: headers,
      })
      .then(function () {
        setTimeout(() => {
          let loadingScreen = document.querySelector("#loading-screen");
          loadingScreen.classList.add("fade-out");
        }, 1000);
      })
      .catch((err) => {
        // console.log(err.response.data.statusCode);
        if (err.response.data.statusCode == 401) {
          localStorage.removeItem("jwt");
          self.$router.push("/");
        } else {
          Swal.fire("Error", `${err}`, "error");
        }
      });

    const query = window.location.search;
    const getParameters = new URLSearchParams(query);
    this.email = getParameters.get("email");
    this.id = getParameters.get("id");
    if (this.id == null || this.email == null) {
      Swal.fire("Error", "This link is not valid.", "error")
        .then(() => {
          this.$router.push("/");
        })
        .catch((err) => {
          Swal.fire("Error", err, "error");
        });
    }
  },
  methods: {
    changePassword() {
      if (this.newPassword.length < 6) {
        Toast.fire(
          "Warning",
          "The password must be 6 characters or longer.",
          "warning"
        );
      } else {
        const headers = {
          Authorization: "Bearer",
          "content-type": "application/json",
        };
        const data = {
          id: this.id,
          email: this.email,
          password: this.newPassword,
        };
        axios
          .post(`${process.env.VUE_APP_BACKEND}/users/reset_password`, data, {
            headers: headers,
          })
          .then(() => {
            Toast.fire(
              "Success",
              "You reset your password successfully. You will soon be redirected to the log in page.",
              "success"
            ).then(() => {
              this.$router.push("/login");
            });
          })
          .catch((err) => {
            Swal.fire("Error", "" + err, "error");
          });
      }
    },
    showPass(id) {
      let inputField = document.querySelector("#" + id);
      if (inputField.getAttribute("type")) {
        inputField.setAttribute("type", "");
      } else {
        inputField.setAttribute("type", "password");
      }
    },
  },
};
</script>

<style scoped>
.reset-prompt {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  background: white;
  padding: 2em;
  margin: 1em;
  margin-block-start: 5em;
  border-radius: 1em;
  box-shadow: var(--light-box-shadow);
  gap: var(--gap);
}

#login-btn {
  justify-self: center;
}

.input-field {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  overflow: visible;
  min-width: 15em;
  width: 100%;
  max-width: 20em;
  position: relative;
}

.input-field > input {
  height: 2rem;
  width: inherit;
  background: white;
  color: var(--dark-clr);
  border-radius: 2rem;
  padding: 0.2rem 1rem;
  margin: 0.2rem;
  border: none;
  box-shadow: var(--box-shadow);
  font-weight: bold;
  transition: 0.5s ease;
}

.input-field > input::placeholder {
  color: var(--mid-dark-clr);
}

.input-field > input:focus {
  border: none;
  box-shadow: var(--box-shadow-focus);
}

.input-field > .icon,
.show-pass > .icon {
  color: var(--primary-clr);
  margin: 0 0.5rem;
}

.show-pass {
  position: absolute;
  right: calc(0% + 1em);
  cursor: pointer;
}

.show-pass:hover > .icon {
  color: var(--mid-dark-clr);
}

p {
  margin-block-end: 1em;
  max-width: 20em;
}

form {
  overflow: visible;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: var(--gap);
}
</style>
